import React, { useContext } from 'react';
import { Typography } from '@mui/material';
import { FlexBox } from '../../../components/tableItems';
import useWeeklyLogStore from '../../../stores/weeklyLog/WeeklyLogStore';
import Context from '../../../context/UserContext';
import { UserContextType } from '../../../models/User';
import { IS_USER_ADMIN } from '../../../constants/user';

interface WeeklyLogTablePagProps {
  page: number;
}

const WeeklyLogTablePag: React.FC<WeeklyLogTablePagProps> = ({ page }) => {
  const { UserContext } = useContext(Context) as UserContextType;
  const { updateWeeklyParams, weeklyReqParams } = useWeeklyLogStore();

  const verifyDisabled = () => {
    if (
      !UserContext.logs_completion.overall_completion &&
      !IS_USER_ADMIN.includes(UserContext.profile.role)
    )
      return true;
    if (weeklyReqParams.start_date && weeklyReqParams.end_date) return true;

    return false;
  };

  return (
    <FlexBox justifyContent="end" gap={1}>
      <Typography
        fontSize={12}
        sx={{
          cursor: verifyDisabled() ? '' : 'pointer',
          borderRadius: '4px',
          border: '0.5px solid #dfdfdf',
          fontSize: '13px',
          padding: '4px 8px',
          color: verifyDisabled()
            ? 'rgba(0, 0, 0, 0.4)'
            : 'rgba(0, 0, 0, 0.87)',

          '&:hover': {
            backgroundColor: verifyDisabled() ? '' : 'rgba(0, 0, 0, 0.04)',
          },

          '@media (min-width: 1900px)': {
            fontSize: '15px',
            padding: '5px 15px',
          },
        }}
        onClick={() => {
          if (verifyDisabled()) return;
          updateWeeklyParams({ prev_week: weeklyReqParams.prev_week + 1 });
        }}
      >
        &larr; Prev Week
      </Typography>
      <Typography
        fontSize={12}
        sx={{
          cursor:
            verifyDisabled() || weeklyReqParams.prev_week === 0
              ? ''
              : 'pointer',
          fontSize: '13px',
          padding: '4px 8px',
          borderRadius: '4px',
          border: '0.5px solid #dfdfdf',
          mx: 0.4,
          color:
            verifyDisabled() || weeklyReqParams.prev_week === 0
              ? 'rgba(0, 0, 0, 0.4)'
              : 'rgba(0, 0, 0, 0.87)',

          '&:hover': {
            backgroundColor:
              verifyDisabled() || weeklyReqParams.prev_week === 0
                ? ''
                : 'rgba(0, 0, 0, 0.04)',
          },
          '@media (min-width: 1900px)': {
            fontSize: '15px',
            padding: '5px 15px',
          },
        }}
        onClick={() => {
          if (verifyDisabled() || weeklyReqParams.prev_week === 0) return;
          updateWeeklyParams({ prev_week: weeklyReqParams.prev_week - 1 });
        }}
      >
        Next Week&rarr;
      </Typography>
    </FlexBox>
  );
};

export default WeeklyLogTablePag;
